import { render } from "./Gallery.vue?vue&type=template&id=7ca669ce&scoped=true"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"

import "./Gallery.vue?vue&type=style&index=0&id=7ca669ce&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-7ca669ce"

export default script